import React, { useMemo } from 'react';
import { createPortal } from 'react-dom';
import clsx from 'clsx';
import './PlanDecisionConfetti.scss';

interface PlanDecisionConfettiProps {
  isVisible: boolean;
}

const PIECE_COUNT = 100;
const COLORS = ['#22c55e', '#3b82f6', '#f97316', '#ec4899', '#f59e0b', '#14b8a6'];

const PlanDecisionConfetti: React.FC<PlanDecisionConfettiProps> = ({ isVisible }) => {
  const pieces = useMemo(
    () =>
      Array.from({ length: PIECE_COUNT }, (_, idx) => {
        const left = Math.random() * 100;
        const delay = Math.random() * 0.45;
        const duration = 2.8 + Math.random() * 1.6;
        const size = 7 + Math.random() * 7;
        const drift = -16 + Math.random() * 32;
        const rotation = Math.floor(Math.random() * 360);
        const color = COLORS[idx % COLORS.length];

        return {
          id: idx,
          style: {
            left: `${left}%`,
            animationDelay: `${delay}s`,
            animationDuration: `${duration}s`,
            width: `${size}px`,
            height: `${Math.max(4, size * 0.6)}px`,
            backgroundColor: color,
            '--confetti-drift': `${drift}px`,
            '--confetti-rotate': `${rotation}deg`,
          } as React.CSSProperties,
        };
      }),
    [isVisible]
  );

  if (typeof document === 'undefined' || !isVisible) {
    return null;
  }

  return createPortal(
    <div className={clsx('plan-decision-confetti', 'plan-decision-confetti--visible')} aria-hidden="true">
      {pieces.map((piece) => (
        <span key={piece.id} className="plan-decision-confetti__piece" style={piece.style} />
      ))}
    </div>,
    document.body
  );
};

export default PlanDecisionConfetti;
